export default {
  data() {
    return {
      list: [],
      origin: {},
      operator: [],
      operatorValue: "",
    };
  },

  created() {
    this.origin = process.env;

    // 采购操作人列表
    this.$store.dispatch("scm/buyerList").then((data) => {
      this.operator = data;
      // 设置列表
      this.$store.dispatch("scm/getBasic").then((data2) => {
        data2.forEach((item, index) => {
          item.entityList.forEach((item2, index2) => {
            if (item2.attr[0] && item2.attr[0].value && item2.code === "purchaser") {
              if (!data.some((item3) => String(item3.boids) === String(item2.attr[0].value))) {
                data2[index].entityList[index2].attr[0].value = "";
              }
            }
          });
        });
        this.list = data2;
      });
    });
  },

  methods: {
    // 更新设置
    updateBasic(value, item, item2) {
      console.log("value", value);
      this.$store
        .dispatch("scm/updateBasic", {
          shopId: item2.shopId,
          groupCode: item.code,
          code: item2.code,
          name: item2.name,
          value: value ? 1 : 0,
          attr: item2.attr,
          attrExplain: item2.attrExplain,
        })
        .then((res = {}) => {
          this.$message.success(res.msg || "系统错误");
        });
    },
  },
};
